// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"MyOrdersPage_tabContainer_3EIoY"};